module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-10.09837b3a.jpg";